import React from 'react';
import CorePage from '../../views/core/CorePage';
import HmAjax from '../../util/HmAjax';

// ES6 class-style
class DownloadContent extends CorePage {
    constructor(props) {
        super(props);

        this.classId = this.props.classId || 0;
        this.accessId = this.props.accessId || 0;
        this.clicked = false;

       this.exportId = this.props.exportId || 0;
    };

    initGenerate(callback){
        let me = this;
        let success = (resp) => {
            me.exportId  = (resp && !isNaN(resp.exportId) && resp.exportId > 0) ? resp.exportId : 0;
            me.clicked = false;
            console.log("resp ::: ", resp);

            if(typeof callback === "function"){
                callback.apply(this);
            }
        }

        let failure = (err) => {
            me.clicked = false;
        }

        if(!this.clicked){
            this.clicked = true;

            let params = {
                "classId" : this.classId,
                "accessId" : this.accessId
            }
            new HmAjax(this.getUrlFor("MS_GENERATE_PDF"),params).post(success,failure);
        }
    }

    initDownload(){
        if(this.exportId){
            let url = this.getUrlFor("MS_DOWNLOAD_PDF").replace("{exportId}",this.exportId);
            window.open(url,"_blank");
        }else{
            console.warn("no export id available");
        }
    }

    downloadFile(){
        //if(!this.exportId){
            this.initGenerate(this.initDownload);
        //}else{
           // this.initDownload();
        //}
    }

    render() {
        let me = this;
        var dynClass = this.props.className || '';
        var dynText = this.props.text || 'btn.download.pdf';
        return(
            <span id="DownloadContent" className={dynClass}>
            <a href="javascript:void(0)" className="download-link">
            <i className="material-icons">picture_as_pdf</i>
            <span className="download-text" onClick={()=>{
                me.downloadFile()
            }
            }>{this.rb(dynText)}</span>
            </a>     
        </span>
       
        )
    }
}

export default DownloadContent;



// WEBPACK FOOTER //
// ./src/vendors/prep/DownloadContent.js